// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__1yzBI","link":"login_link__vAUi8"};